const fullscreenOverlay = function() {

    /* Too open overlay use the following custom event.
     *   Content could be a string or a HTML node
     *
     *   const event = new CustomEvent(
     *       "fullscreenOverlay:show",
     *       {
     *           content: "<strong>Hello World!</strong>",
     *       }
     *   );
     *
     *   document.dispatchEvent(event);
     */

    const defaults = {
        selectors: {
            container: "#fullscreenOverlay",
            content: ".fullscreenOverlay-content",
        },
        durations: {
            fadeIn: 500,
            fadeOut: 500,
        },
    };

    const properties = {
        isVisible: false,
    }

    const data = {
        properties: properties,
        durations: defaults.durations,
        content: "",
    };

    const container = document.querySelector(defaults.selectors.container);

    const init = function () {

        if (! container) {
            return;
        }

        // Setup event for opening modal

        document.addEventListener(
            'fullscreenOverlay:show',
            (event) => {

                if (! event.detail  || ! event.detail.content) {
                    console.warn("fullscreenOverlay: Suppress showing empty modal.");
                    return;
                }

                show(event.detail.content);

            },
            false
        );

            // Add keyboard controls (only active if slideshow is focused)

        document.addEventListener('keydown', function(e) {

            if (! properties.isVisible) {
                return true;
            }

            let prevent_default = false;

            if ([27, 32].indexOf(e.keyCode) !== -1) {
                prevent_default = true;
                hide();
            }

            if (prevent_default) {
                e.preventDefault();
            }

        });

        // Init vue

        new Vue({
            el: defaults.selectors.container,
            data: data,
            methods: {
                show: (index) => { show(index) },
                hide: (index) => { hide(index) },
            },
        });

    }

    const show = function(content) {

        if (content) {

            const container = document.querySelector(defaults.selectors.container + " " + defaults.selectors.content);

            if (container) {

                if (typeof content === "object") {
                    container.innerHTML = "";
                    container.append(content);
                } else {
                    container.innerHTML = content;
                }

            }

            data.content = content;

        }

        toggle(true);

    }

    const hide = function() {

            // Blur all slideshows

        const blur = new CustomEvent(
            "imageSlider:blur"
        );

        document.dispatchEvent(blur);

            // Hide

        toggle(false);

    }

    const toggle = function(show) {

        show  = (typeof show === "boolean") ? show : !properties.isVisible;

        properties.isVisible = show;

        const node = document.querySelector("html"),
              class_name = "fullscreenOverlay-is-visible";

        if (show) {
            node.classList.add(class_name);
        } else {
            node.classList.remove(class_name);
        }

    }

        /*****************************************/
        /******//* !Return public method *//******/
        /*****************************************/

    return {
        init: init,
        show: show,
        hide: hide,
        data: data,
    }

}();

fullscreenOverlay.init();
